<template>
    <div>
        <b-container fluid class="mt--7">
            <location-list
                v-if="isList"
                title="Locations Management"
                :loading="loading"
                ref="table"
            >
                <b-row>
                    <b-col offset="10" class="text-right">
                        <b-button
                            size="sm"
                            variant="primary"
                            :to="`${$route.path}/0`"
                            >Add Location</b-button
                        >
                    </b-col>
                </b-row>
            </location-list>
            <location-view
                v-else
                :id="id"
                :loading="loading"
                @save-location="saveLocation"
                @delete-section="deleteSection"
                @save-section="saveSection"
                @delete-location="deleteLocation"
            />
        </b-container>
    </div>
</template>
<script>
import LocationList from './LocationList'
import LocationView from './LocationView'

import popupMixins from '@/mixins/popupMixins'

import showItemHelper from '@/mixins/showItemHelper'

export default {
    name: 'Location',
    components: {
        LocationList,
        LocationView,
    },
    mixins: [popupMixins, showItemHelper],
    data: () => {
        return {
            loading: false,
        }
    },

    methods: {
        saveLocation(payload) {
            this.loading = true
            const id = payload.id
            delete payload.id
            const path = id ? 'locations/update' : 'locations/create'
            const title = id ? 'Location Updated' : 'Location Created'
            const type = 'success'
            this.$store
                .dispatch(path, { id, payload })
                .then(() => {
                    this.doToast('Success!', title, type)
                    this.$router.go(-1)
                })
                .catch(error => {
                    this.doToast('Error!', error.message, 'danger')
                })
                .finally(() => {
                    this.loading = false
                })
        },

        /**
         * Stores the section data
         */
        saveSection({ section, location_id }) {
            this.loading = true
            console.log('section', section)
            console.log('location_id', location_id)
            const { id, name } = section

            // Check if the Section is empty
            if (name == null) {
                this.doToast(
                    'Error!',
                    'Please enter the name of the Location Section',
                    'danger'
                )

                return
            }
            // const { id: location_id } = this.item
            const payload = { name }
            const path = id
                ? 'locations/updateSection'
                : 'locations/createSection'

            this.$store
                .dispatch(path, {
                    location_id,
                    id,
                    payload,
                })
                .then(() => {
                    console.log('Location is ', this.locationSections)
                    this.doToast(
                        'Success!',
                        'Location Section Successfully Saved',
                        'success'
                    )
                })
                // Catch all block for unhandled errors
                .catch(error => {
                    console.log(error.message)
                    this.doToast('Error!', 'Unable to store section.', 'danger')
                })
                .finally(() => {
                    this.updating = false
                    this.$forceUpdate()
                })
        },

        deleteLocation(id) {
            this.loading = true
            this.confirmMessage(
                'Delete Location?',
                `Are you sure you want to delete the Location?`
            )
                .then(result => {
                    if (result) {
                        this.$store
                            .dispatch('locations/delete', id)
                            .then(() => {
                                this.doToast(
                                    'Deleted!',
                                    'Location has been deleted.',
                                    'success'
                                )
                            })
                            .catch(error => {
                                console.error(error)
                                this.doToast(
                                    'Error!',
                                    'Unable to delete Location! There is an association with this location',
                                    'danger'
                                )
                            })
                    }
                })
                .finally(() => {
                    this.loading = false
                    this.$router.go(-1)
                })
        },

        deleteSection({ id, location_id }) {
            this.loading = true
            this.confirmMessage(
                'Delete Location Section?',
                `Are you sure you want to delete this Location Section?`
            )
                .then(result => {
                    if (result) {
                        this.$store
                            .dispatch('locations/deleteSection', {
                                id,
                                location_id,
                            })
                            .then(() => {
                                this.doToast(
                                    'Deleted!',
                                    'Location Section has successfully been deleted.',
                                    'success'
                                )
                            })
                            .catch(error => {
                                console.log('error message', error)
                                const message =
                                    'Cannot Delete Section. There are associations with this Location Section'
                                this.doToast('Error!', message, 'danger')
                            })
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
    },
}
</script>
<style></style>
